export const getPhaseShortName = (phase) => {
  const phaseNames = {
    'field_preparation': 'Редактирование поля',
    'setup': 'Стартовые кварталы',
    'supply': 'Снабжение',
    'construction': 'Строительство',
    'war': 'Война'
  };
  return phaseNames[phase] || phase;
};